import { GetCommentOutDto, GetCommentInDto } from "../../../types/comment.dto";

export const GET_COMMENTS_FACTURACION = "GET_COMMENTS_FACTURACION";
export const GET_COMMENTS_FACTURACION_SUCCESS =
  "GET_COMMENTS_FACTURACION_SUCCESS";
export const GET_COMMENTS_FACTURACION_ERROR = "GET_COMMENTS_FACTURACION_ERROR";
export const RESET_GET_COMMENTS_FACTURACION = "RESET_GET_COMMENTS_FACTURACION";

export interface GetCommentsFacturacion {
  type: typeof GET_COMMENTS_FACTURACION;
  payload: GetCommentOutDto;
}

export interface GetCommentsFacturacionSuccess {
  type: typeof GET_COMMENTS_FACTURACION_SUCCESS;
  payload: GetCommentInDto[];
}

export interface GetCommentsFacturacionError {
  type: typeof GET_COMMENTS_FACTURACION_ERROR;
  payload: string | boolean;
}

export interface ResetGetCommentsFacturacion {
  type: typeof RESET_GET_COMMENTS_FACTURACION;
  payload: null;
}

export interface State {
  data: GetCommentInDto[] | null;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
};

export type Actions =
  | GetCommentsFacturacion
  | GetCommentsFacturacionSuccess
  | GetCommentsFacturacionError
  | ResetGetCommentsFacturacion;
